"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Backdrop = exports.Footer = exports.Content = exports.Description = exports.Title = exports.Header = exports.Dialog = exports.StyledBackdrop = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0,0,0,0.6);\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n\n  &.pui-backdrop--hidden {\n    display: none;\n  }\n\n  .pui-dialog {\n    min-width: 200px;\n    min-height: 200px;\n    width: calc(100% - 40px);\n    max-width: calc(100vw - 40px);\n    background-color: #ffffff;\n    border-radius: 3px;\n    box-shadow: 0px 0px 5px rgba(0,0,0,0.25), 3px 3px 5px rgba(0,0,0,0.25);\n    font-size: 14px;\n    font-family: 'Raleway',sans-serif;\n    color: #5b5b5b;\n    padding: 32px;\n    box-sizing: border-box;\n  }\n\n  .pui-dialog--size-large {\n    max-width: 800px;\n  }\n\n  .pui-dialog--size-medium {\n    max-width: 500px;\n  }\n\n  .pui-dialog--size-small {\n    max-width: 415px;\n  }\n\n  .pui-dialog__title {\n    font-size: 16px;\n    font-family: 'Raleway', sans-serif;\n    color: #5b5b5b;\n    text-transform: uppercase;\n    font-weight: bold;\n    display: block;\n    margin-bottom: 32px;\n  }\n\n  .pui-dialog__description {\n    font-size: 14px;\n    font-family: 'Raleway', sans-serif;\n    color: #5b5b5b;\n    display: block;\n  }\n\n  .pui-dialog__header, .pui-dialog__content {\n    margin-bottom: 16px;\n  }\n\n  .pui-dialog__footer {\n    display: flex;\n    justify-content: flex-end;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBackdrop = _styledComponents["default"].div(_templateObject());

exports.StyledBackdrop = StyledBackdrop;

var Dialog = function Dialog(_ref) {
  var className = _ref.className,
      size = _ref.size,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "size", "children"]);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, 'pui-dialog', "pui-dialog--size-".concat(size))
  }), children);
};

exports.Dialog = Dialog;
Dialog.propTypes = {
  open: _propTypes["default"].bool.isRequired
};
Dialog.defaultProps = {
  open: false,
  size: 'medium'
};

var Header = function Header(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement('div', _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, 'pui-dialog__header')
  }), children);
};

exports.Header = Header;

var Title = function Title(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement('div', _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, 'pui-dialog__title')
  }), children);
};

exports.Title = Title;

var Description = function Description(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement('div', _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, 'pui-dialog__description')
  }), children);
};

exports.Description = Description;

var Content = function Content(_ref5) {
  var className = _ref5.className,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement('div', _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, 'pui-dialog__content')
  }), children);
};

exports.Content = Content;

var Footer = function Footer(_ref6) {
  var className = _ref6.className,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement('div', _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, 'pui-dialog__footer')
  }), children);
};

exports.Footer = Footer;

var Backdrop = function Backdrop(_ref7) {
  var className = _ref7.className,
      open = _ref7.open,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["className", "open", "children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledBackdrop, _extends({}, props, {
    open: open,
    className: (0, _clsx["default"])(className, 'pui-dialog__backdrop', {
      'pui-backdrop--hidden': !Boolean(open)
    })
  }), children);
};

exports.Backdrop = Backdrop;
Backdrop.propTypes = {
  open: _propTypes["default"].bool.isRequired
};
Backdrop.defaultProps = {
  open: false
};

var DialogWrapper = function DialogWrapper(_ref8) {
  var open = _ref8.open,
      children = _ref8.children,
      props = _objectWithoutProperties(_ref8, ["open", "children"]);

  return /*#__PURE__*/_react["default"].createElement(Backdrop, {
    open: open
  }, /*#__PURE__*/_react["default"].createElement(Dialog, _extends({}, props, {
    open: open
  }), children));
};

DialogWrapper.propTypes = {
  open: _propTypes["default"].bool.isRequired
};
DialogWrapper.defaultProps = {
  open: false
};
var _default = DialogWrapper;
exports["default"] = _default;